/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MoreCircle = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12ZM6.3501 14C7.3166 14 8.1001 13.2165 8.1001 12.25C8.1001 11.2835 7.3166 10.5 6.3501 10.5C5.3836 10.5 4.6001 11.2835 4.6001 12.25C4.6001 13.2165 5.3836 14 6.3501 14ZM11.8501 14C12.8166 14 13.6001 13.2165 13.6001 12.25C13.6001 11.2835 12.8166 10.5 11.8501 10.5C10.8836 10.5 10.1001 11.2835 10.1001 12.25C10.1001 13.2165 10.8836 14 11.8501 14ZM19.1001 12.25C19.1001 13.2165 18.3166 14 17.3501 14C16.3836 14 15.6001 13.2165 15.6001 12.25C15.6001 11.2835 16.3836 10.5 17.3501 10.5C18.3166 10.5 19.1001 11.2835 19.1001 12.25Z"
                        fill={color}
                    />
                </svg>
        );
    };
